import { render, staticRenderFns } from "./JobsListItem.vue?vue&type=template&id=7ae448d6&"
import script from "./JobsListItem.vue?vue&type=script&lang=ts&"
export * from "./JobsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonSecondary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonSecondary.vue').default})
